import {
  Header_styles_default
} from "./chunk.P3X7JL3M.js";
import {
  o
} from "./chunk.DWZR6NQN.js";
import {
  n
} from "./chunk.W5GYKEPL.js";
import {
  $,
  s
} from "./chunk.X63DNLWS.js";
import {
  __decorateClass
} from "./chunk.LKRKSA4X.js";

// packages/web-components/src/components/Header/Header.ts
var Header = class extends s {
  render() {
    return $`
      <div
        part="base"
        class=${o({
      header: true,
      "myd-header": true,
      header__border: true
    })}
      >
        <div part="leading" class="header__leading-element">
          <slot name="leading"></slot>
        </div>
        <div part="trailing" class="header__trailing-element">
          <slot name="trailing"></slot>
        </div>
      </div>
    `;
  }
};
Header.styles = Header_styles_default;
Header = __decorateClass([
  n("myd-header")
], Header);

export {
  Header
};
